export default "__VITE_ASSET__cf55f8b9__"